export default __webpack_public_path__ + "static/media/pharma-exte.74f6e6ee.jpg";